<emed-topbar [projectTitle]="configOptions.projectName">
  <!-- Dropdown lingua -->
  <div class="w-full" style="cursor: default" end-content>
    <div class="px-2 py-2 flex flex-row items-center">
      <!-- <p-select
        [options]="lingue"
        [(ngModel)]="linguaSelezionata"
        dataKey="id"
        valueKey="id"
        [style]="{ width: '100px' }"
        (onChange)="changeTraduzione($event.value)"
        styleClass="mm-menu-row"
      >
        <ng-template let-selected pTemplate="selectedItem">
          <div class="flex flex-col">
            <img [src]="selected.path" style="width: 25px" />
          </div>
        </ng-template>

        <ng-template let-language pTemplate="item">
          <div class="flex flex-row items-center">
            <img [src]="language.path" style="width: 25px" />
            <div class="ml-2">{{ language.sigla }}</div>
          </div>
        </ng-template>
      </p-select> -->
    </div>
  </div>

  <!-- Selezione tema -->
  <div class="w-full" style="cursor: default" end-content>
    <div class="px-2 py-2 flex flex-row items-center">
      <i class="text-xl ml-1 mm-menu-row text-white" [ngClass]="changeIcon()" (click)="toggleDarkMode()" group-end></i>
    </div>
  </div>

  @if (isAuthenticated) {
  <div class="w-full" style="cursor: default" end-content>
    <div class="px-2 py-2 flex flex-row items-center">
      <i class="my-icon-size-header-max ml-1 my-menu-row text-white fa-solid fa-circle-user" [pTooltip]="idToken?.email" tooltipPosition="bottom"></i>
      <i
        class="my-icon-size-header-max ml-1 my-menu-row text-white"
        [class]="'fa-solid fa-right-from-bracket'"
        (click)="logout()"
        pTooltip="Logout"
        tooltipPosition="bottom"
        group-end
      ></i>
    </div>
  </div>
  }
</emed-topbar>

<router-outlet></router-outlet>

<!-- Modale avviso cancella -->
@if (displayCancellaDialog) {
<p-dialog
  [modal]="true"
  header="Cancella voce"
  [(visible)]="displayCancellaDialog"
  position="center"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [blockScroll]="true"
  [style]="{ width: '20vw' }"
>
  <div class="flex flex-col" style="flex: 1">
    <div class="text-center mb-4">
      <i class="fa-solid fa-trash" style="font-size: 3rem"></i>
      <h4 class="my-2">Cancellare la voce corrente?</h4>
      <p class="my-2">Conferma per procedere</p>
    </div>
    <div class="grid grid-cols-12 gap-2 p-fluid">
      <div class="col-span-6">
        <p-button label="Cancella" styleClass="w-full p-button-danger" (onClick)="setCancella(true)"></p-button>
      </div>
      <div class="col-span-6">
        <p-button label="Annulla" styleClass="w-full p-button-secondary" (onClick)="setCancella(false)"></p-button>
      </div>
    </div>
  </div>
</p-dialog>
}
